import React from 'react';
import { Loader2 } from 'lucide-react';

export default function SubmittingStage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center">
        <div className="w-20 h-20 mx-auto mb-6 bg-slate-800 rounded-2xl flex items-center justify-center">
          <Loader2 className="w-10 h-10 text-amber-400 animate-spin" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">Submitting to A+</h2>
        <p className="text-slate-400">Creating sales order...</p>
      </div>
    </div>
  );
}
